import { ICardstourdesksItem, IpaginatedCardstourdesks } from '../models'

export enum CardstourdesksActionTypes {
  SEARCH_CARDSTOURDESKS = 'cardstourdesks/search',
  SEARCHING_CARDSTOURDESKS = 'cardstourdesks/searching',
  FOUND_CARDSTOURDESKS = 'cardstourdesks/found',
  SEARCHING_CARDSTOURDESKS_FAILED = 'cardstourdesks/searching_failed',

  LOAD_CARDSTOURDESKS = 'cardstourdesks/load',
  LOADING_CARDSTOURDESKS = 'cardstourdesks/loading',
  LOADED_CARDSTOURDESKS = 'cardstourdesks/loaded',
  LOADING_CARDSTOURDESKS_FAILED = 'cardstourdesks/loading_failed',

  ADD_CARDSTOURDESKS = 'cardstourdesks/add',
  ADDING_CARDSTOURDESKS = 'cardstourdesks/adding',
  ADDED_CARDSTOURDESKS = 'cardstourdesks/added',
  ADDING_CARDSTOURDESKS_FAILED = 'cardstourdesks/adding_failed',

  REMOVE_CARDSTOURDESK = 'cardstourdesks/remove',
  REMOVING_CARDSTOURDESK = 'cardstourdesks/removing',
  REMOVED_CARDSTOURDESK = 'cardstourdesks/removed',
  REMOVING_CARDSTOURDESK_FAILED = 'cardstourdesks/removing_failed',

  SOFT_REMOVE_CARDSTOURDESKS = 'cardstourdesks/soft_remove',
  SOFT_REMOVING_CARDSTOURDESKS = 'cardstourdesks/soft_removing',
  SOFT_REMOVED_CARDSTOURDESKS = 'cardstourdesks/soft_removed',
  SOFT_REMOVING_CARDSTOURDESKS_FAILED = 'cardstourdesks/soft_removing_failed',

  EDIT_CARDSTOURDESKS = 'cardstourdesks/edit',
  EDITING_CARDSTOURDESKS = 'cardstourdesks/editing',
  EDITED_CARDSTOURDESKS = 'cardstourdesks/edited',
  EDITING_CARDSTOURDESKS_FAILED = 'cardstourdesks/editing_failed',

  VIEW_CARDSTOURDESKS = 'cardstourdesks/view',
  VIEWING_CARDSTOURDESKS = 'cardstourdesks/viewing',
  VIEWED_CARDSTOURDESKS = 'cardstourdesks/viewed',
  VIEWING_CARDSTOURDESKS_FAILED = 'cardstourdesks/viewing_failed',
}

export function searchCardstourdesks(searchOptions: TSearchOptions | string, keep?: boolean): ISearchCardstourdesksAction {
  return {
    type: CardstourdesksActionTypes.SEARCH_CARDSTOURDESKS,
    searchOptions: typeof searchOptions === 'string' ? { searchString: searchOptions } : searchOptions,
    keep: keep,
  }
}

export function searchingCardstourdesks(): ISearchingCardstourdesksAction {
  return {
    type: CardstourdesksActionTypes.SEARCHING_CARDSTOURDESKS,
  }
}

export function foundCardstourdesks(cardstourdesks: IpaginatedCardstourdesks, keep?: boolean): IFoundCardstourdesksAction {
  return {
    type: CardstourdesksActionTypes.FOUND_CARDSTOURDESKS,
    keep: keep,
    payload: {
      cardstourdesks,
    },
  }
}

export function searchingCardstourdesksFailed(): ISearchingCardstourdesksFailedAction {
  return {
    type: CardstourdesksActionTypes.SEARCHING_CARDSTOURDESKS_FAILED,
  }
}

export function loadCardstourdesks(loadOptions: TSearchOptions): ILoadCardstourdesksAction {
  return {
    type: CardstourdesksActionTypes.LOAD_CARDSTOURDESKS,
    loadOptions: loadOptions,
  }
}

export function loadingCardstourdesks(): ILoadingCardstourdesksAction {
  return {
    type: CardstourdesksActionTypes.LOADING_CARDSTOURDESKS,
  }
}

export function loadedCardstourdesks(cardstourdesks: IpaginatedCardstourdesks): ILoadedCardstourdesksAction {
  return {
    type: CardstourdesksActionTypes.LOADED_CARDSTOURDESKS,
    payload: {
      cardstourdesks,
    },
  }
}

export function loadingCardstourdesksFailed(): ILoadingCardstourdesksFailedAction {
  return {
    type: CardstourdesksActionTypes.LOADING_CARDSTOURDESKS_FAILED,
  }
}

export function addCardstourdesks(cardstourdesk: ICardstourdesksItem): IAddCardstourdesksAction {
  return {
    type: CardstourdesksActionTypes.ADD_CARDSTOURDESKS,
    payload: cardstourdesk,
  }
}

export function addingCardstourdesks(): IAddingCardstourdesksAction {
  return {
    type: CardstourdesksActionTypes.ADDING_CARDSTOURDESKS,
  }
}

export function addedCardstourdesks(cardstourdesks: IpaginatedCardstourdesks): IAddedCardstourdesksAction {
  return {
    type: CardstourdesksActionTypes.ADDED_CARDSTOURDESKS,
    payload: {
      cardstourdesks,
    },
  }
}

export function addingCardstourdesksFailed(errData: {
  data: { message: string; field?: string }
  status: number
}): IAddingCardstourdesksFailedAction {
  return {
    type: CardstourdesksActionTypes.ADDING_CARDSTOURDESKS_FAILED,
    message: errData.data.message,
    status: errData.status,
    field: errData.data.field,
  }
}

export function removeCardstourdesk(cardstourdesk: ICardstourdesksItem): IRemoveCardstourdeskAction {
  return {
    type: CardstourdesksActionTypes.REMOVE_CARDSTOURDESK,
    payload: cardstourdesk,
  }
}

export function removingCardstourdesk(): IRemovingCardstourdeskAction {
  return {
    type: CardstourdesksActionTypes.REMOVING_CARDSTOURDESK,
  }
}

export function removedCardstourdesk(): IRemovedCardstourdeskAction {
  return {
    type: CardstourdesksActionTypes.REMOVED_CARDSTOURDESK,
  }
}

export function removingCardstourdeskFailed(): IRemovingCardstourdeskFailedAction {
  return {
    type: CardstourdesksActionTypes.REMOVING_CARDSTOURDESK_FAILED,
  }
}

export function softRemoveCardstourdesks(cardstourdesk: ICardstourdesksItem): ISoftRemoveCardstourdesksAction {
  return {
    type: CardstourdesksActionTypes.SOFT_REMOVE_CARDSTOURDESKS,
    payload: cardstourdesk,
  }
}

export function softRemovingCardstourdesks(): ISoftRemovingCardstourdesksAction {
  return {
    type: CardstourdesksActionTypes.SOFT_REMOVING_CARDSTOURDESKS,
  }
}

export function softRemovedCardstourdesks(cardstourdesk: ICardstourdesksItem): ISoftRemovedCardstourdesksAction {
  return {
    type: CardstourdesksActionTypes.SOFT_REMOVED_CARDSTOURDESKS,
    payload: cardstourdesk,
  }
}

export function softRemovingCardstourdesksFailed(errData: {
  data: { message: string; field?: string }
  status: number
}): ISoftRemovingCardstourdesksFailedAction {
  return {
    type: CardstourdesksActionTypes.SOFT_REMOVING_CARDSTOURDESKS_FAILED,
    message: errData.data.message,
    status: errData.status,
    field: errData.data.field,
  }
}

export function editCardstourdesks(cardstourdesk: ICardstourdesksItem): IEditCardstourdesksAction {
  return {
    type: CardstourdesksActionTypes.EDIT_CARDSTOURDESKS,
    payload: cardstourdesk,
  }
}

export function editingCardstourdesks(): IEditingCardstourdesksAction {
  return {
    type: CardstourdesksActionTypes.EDITING_CARDSTOURDESKS,
  }
}

export function editedCardstourdesks(cardstourdesks: ICardstourdesksItem): IEditedCardstourdesksAction {
  return {
    type: CardstourdesksActionTypes.EDITED_CARDSTOURDESKS,
    payload: cardstourdesks,
  }
}

export function editingCardstourdesksFailed(errData: {
  data: { message: string; field?: string }
  status: number
}): IEditingCardstourdesksFailedAction {
  return {
    type: CardstourdesksActionTypes.EDITING_CARDSTOURDESKS_FAILED,
    message: errData.data.message,
    status: errData.status,
    field: errData.data.field,
  }
}

export function viewCardstourdesks(cardstourdesk: ICardstourdesksItem): IViewCardstourdesksAction {
  return {
    type: CardstourdesksActionTypes.VIEW_CARDSTOURDESKS,
    payload: cardstourdesk,
  }
}

export function viewingCardstourdesks(): IViewingCardstourdesksAction {
  return {
    type: CardstourdesksActionTypes.VIEWING_CARDSTOURDESKS,
  }
}

export function viewedCardstourdesks(cardstourdesks: ICardstourdesksItem): IViewedCardstourdesksAction {
  return {
    type: CardstourdesksActionTypes.VIEWED_CARDSTOURDESKS,
    payload: cardstourdesks,
  }
}

export function viewingCardstourdesksFailed(): IViewingCardstourdesksFailedAction {
  return {
    type: CardstourdesksActionTypes.VIEWING_CARDSTOURDESKS_FAILED,
  }
}

type TSearchOptions = {
  searchString?: string
  searchField?: string
  page?: number
  limit?: number
  populate?: boolean
  sort?: {
    field: string
    method?: 'asc' | 'desc'
  }
  filters?: { field: string; value: string }[]
}

export interface ISearchCardstourdesksAction {
  type: CardstourdesksActionTypes.SEARCH_CARDSTOURDESKS
  searchOptions: TSearchOptions
  keep?: boolean
}

export interface ISearchingCardstourdesksAction {
  type: CardstourdesksActionTypes.SEARCHING_CARDSTOURDESKS
}

export interface IFoundCardstourdesksAction {
  type: CardstourdesksActionTypes.FOUND_CARDSTOURDESKS
  keep?: boolean
  payload: {
    cardstourdesks: IpaginatedCardstourdesks
  }
}

export interface ISearchingCardstourdesksFailedAction {
  type: CardstourdesksActionTypes.SEARCHING_CARDSTOURDESKS_FAILED
}

export interface ILoadCardstourdesksAction {
  type: CardstourdesksActionTypes.LOAD_CARDSTOURDESKS
  loadOptions: TSearchOptions
}

export interface ILoadingCardstourdesksAction {
  type: CardstourdesksActionTypes.LOADING_CARDSTOURDESKS
}

export interface ILoadedCardstourdesksAction {
  type: CardstourdesksActionTypes.LOADED_CARDSTOURDESKS
  payload: {
    cardstourdesks: IpaginatedCardstourdesks
  }
}

export interface ILoadingCardstourdesksFailedAction {
  type: CardstourdesksActionTypes.LOADING_CARDSTOURDESKS_FAILED
}

export interface IAddCardstourdesksAction {
  type: CardstourdesksActionTypes.ADD_CARDSTOURDESKS
  payload: ICardstourdesksItem
}

export interface IAddingCardstourdesksAction {
  type: CardstourdesksActionTypes.ADDING_CARDSTOURDESKS
}

export interface IAddedCardstourdesksAction {
  type: CardstourdesksActionTypes.ADDED_CARDSTOURDESKS
  payload: {
    cardstourdesks: IpaginatedCardstourdesks
  }
}

export interface IAddingCardstourdesksFailedAction {
  type: CardstourdesksActionTypes.ADDING_CARDSTOURDESKS_FAILED
  message: string
  status: number
  field?: string
}

export interface IRemoveCardstourdeskAction {
  type: CardstourdesksActionTypes.REMOVE_CARDSTOURDESK
  payload: ICardstourdesksItem
}

export interface IRemovingCardstourdeskAction {
  type: CardstourdesksActionTypes.REMOVING_CARDSTOURDESK
}

export interface IRemovedCardstourdeskAction {
  type: CardstourdesksActionTypes.REMOVED_CARDSTOURDESK
}

export interface IRemovingCardstourdeskFailedAction {
  type: CardstourdesksActionTypes.REMOVING_CARDSTOURDESK_FAILED
}

export interface ISoftRemoveCardstourdesksAction {
  type: CardstourdesksActionTypes.SOFT_REMOVE_CARDSTOURDESKS
  payload: ICardstourdesksItem
}

export interface ISoftRemovingCardstourdesksAction {
  type: CardstourdesksActionTypes.SOFT_REMOVING_CARDSTOURDESKS
}

export interface ISoftRemovedCardstourdesksAction {
  type: CardstourdesksActionTypes.SOFT_REMOVED_CARDSTOURDESKS
  payload: ICardstourdesksItem
}

export interface ISoftRemovingCardstourdesksFailedAction {
  type: CardstourdesksActionTypes.SOFT_REMOVING_CARDSTOURDESKS_FAILED
  message: string
  status: number
  field?: string
}

export interface IEditCardstourdesksAction {
  type: CardstourdesksActionTypes.EDIT_CARDSTOURDESKS
  payload: ICardstourdesksItem
}

export interface IEditingCardstourdesksAction {
  type: CardstourdesksActionTypes.EDITING_CARDSTOURDESKS
}

export interface IEditedCardstourdesksAction {
  type: CardstourdesksActionTypes.EDITED_CARDSTOURDESKS
  payload: ICardstourdesksItem
}

export interface IEditingCardstourdesksFailedAction {
  type: CardstourdesksActionTypes.EDITING_CARDSTOURDESKS_FAILED
  message: string
  status: number
  field?: string
}

export interface IViewCardstourdesksAction {
  type: CardstourdesksActionTypes.VIEW_CARDSTOURDESKS
  payload: ICardstourdesksItem
}

export interface IViewingCardstourdesksAction {
  type: CardstourdesksActionTypes.VIEWING_CARDSTOURDESKS
}

export interface IViewedCardstourdesksAction {
  type: CardstourdesksActionTypes.VIEWED_CARDSTOURDESKS
  payload: ICardstourdesksItem
}

export interface IViewingCardstourdesksFailedAction {
  type: CardstourdesksActionTypes.VIEWING_CARDSTOURDESKS_FAILED
}

export type CardstourdesksAction =
  | ISearchCardstourdesksAction
  | ISearchingCardstourdesksAction
  | IFoundCardstourdesksAction
  | ISearchingCardstourdesksFailedAction
  | ILoadCardstourdesksAction
  | ILoadingCardstourdesksAction
  | ILoadedCardstourdesksAction
  | ILoadingCardstourdesksFailedAction
  | IAddCardstourdesksAction
  | IAddingCardstourdesksAction
  | IAddedCardstourdesksAction
  | IAddingCardstourdesksFailedAction
  | IRemoveCardstourdeskAction
  | IRemovingCardstourdeskAction
  | IRemovedCardstourdeskAction
  | IRemovingCardstourdeskFailedAction
  | ISoftRemoveCardstourdesksAction
  | ISoftRemovingCardstourdesksAction
  | ISoftRemovedCardstourdesksAction
  | ISoftRemovingCardstourdesksFailedAction
  | IEditCardstourdesksAction
  | IEditingCardstourdesksAction
  | IEditedCardstourdesksAction
  | IEditingCardstourdesksFailedAction
  | IViewCardstourdesksAction
  | IViewingCardstourdesksAction
  | IViewedCardstourdesksAction
  | IViewingCardstourdesksFailedAction
